import {
    useQuery,
} from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import Overlay from '../../Components/Overlay'

import backgroundCheckForms from './services/background-check-forms'

const CandidateHome = () => {
    const navigate = useNavigate()

    const { data, isLoading } = useQuery({
        queryKey: ['background-check-forms'],
        queryFn: () => backgroundCheckForms(),
    })

    const handleClick = (check) => {
        navigate(`/background-check-form?referenceNumber=${check.referenceNumber}`)
    }

    return (
        <>
            <div className="p-4">
                {/* Hero/Intro Section */}
                <section className="w-full max-w-4xl mx-auto mb-4 p-3 bg-gradient-to-r from-blue-50 to-blue-100 rounded-lg shadow flex flex-col items-center text-center">
                    <h1 className="text-lg sm:text-xl font-bold text-blue-800 mb-1">Background Verification Portal</h1>
                    <p className="text-gray-700 text-xs sm:text-sm mb-2 max-w-xl">
                        Submit your details for background verification (BGV) as requested by your company HR. <br/>Review your cases and complete any pending forms below.
                    </p>
                    <div className="flex flex-col sm:flex-row gap-1 justify-center">
                        <span className="inline-block bg-blue-200 text-blue-900 px-2 py-0.5 rounded text-xs font-semibold">Secure</span>
                        <span className="inline-block bg-green-200 text-green-900 px-2 py-0.5 rounded text-xs font-semibold">Fast</span>
                        <span className="inline-block bg-yellow-100 text-yellow-800 px-2 py-0.5 rounded text-xs font-semibold">Support</span>
                    </div>
                </section>

                {/* Desktop/tablet: show labels only once above all cards */}
                <div className="hidden sm:grid grid-cols-4 gap-1 text-sm font-semibold text-gray-600 border-b pb-1 mb-1 max-w-6xl mx-auto">
                    <div>Case Reference Number</div>
                    <div>Company Name</div>
                    <div>Status</div>
                    <div>Date of Creation</div>
                </div>
                {data && data.map((check) => (
                    <div
                        className="flex flex-col gap-1 max-w-6xl cursor-pointer mx-auto" key={check.referenceNumber}
                        onClick={() => handleClick(check)}
                    >
                        <div className="p-2 bg-white rounded border border-gray-300 hover:bg-gray-100 transition-colors mb-1">
                            {/* Mobile layout: show label and value in a row, stacked vertically */}
                            <div className="flex flex-col gap-0.5 sm:hidden">
                                <div className="flex justify-between text-sm font-semibold text-gray-600">
                                    <span>Case Reference Number</span>
                                    <span className="text-sm font-normal text-gray-800 break-all">{check.referenceNumber}</span>
                                </div>
                                <div className="flex justify-between text-sm font-semibold text-gray-600">
                                    <span>Company Name</span>
                                    <span className="text-sm font-normal text-gray-800 break-all">{check.companyName || check.referenceNumber}</span>
                                </div>
                                <div className="flex justify-between text-sm font-semibold text-gray-600">
                                    <span>Status</span>
                                    <span className="text-sm font-normal text-gray-800">{check.status}</span>
                                </div>
                                <div className="flex justify-between text-sm font-semibold text-gray-600">
                                    <span>Date of Creation</span>
                                    <span className="text-sm font-normal text-gray-800">{new Date(check.createdAt).toLocaleDateString()}</span>
                                </div>
                            </div>
                            {/* Desktop/tablet layout: 4 columns, 1 row per card, no repeated labels */}
                            <div className="hidden sm:grid grid-cols-4 gap-1 text-sm">
                                <div className="break-all">{check.referenceNumber}</div>
                                <div className="break-all">{check.companyName || check.referenceNumber}</div>
                                <div>{check.status === "completed" ? "Completed": check.status}</div>
                                <div>{new Date(check.createdAt).toLocaleDateString()}</div>
                            </div>
                        </div>
                    </div>
                ))}

                {isLoading && <Overlay />}
            </div>
        </>
    )
}

export default CandidateHome
